export default __webpack_public_path__ + "static/media/13.ee59bde1.jpg";